import { IFilters } from '../../../utils/component/base-filter-component/IFilter';
import { SequenceJsonModel } from '../../sequence.json.model';

export namespace SequenceActions {
  export class Add {
    static readonly type = getActionName('Add');
    constructor(
      public payload: SequenceJsonModel,
      public type: string,
      public filters?: IFilters
    ) { }
  }

  export class Copy {
    static readonly type = getActionName('Copy');
    constructor(
      public payload: SequenceJsonModel,
      public type: string,
      public filters?: IFilters
    ) { }
  }

  export class Edit {
    static readonly type = getActionName('Edit');
    constructor(
      public payload: SequenceJsonModel,
      public filters?: IFilters
    ) { }
  }

  export class Delete {
    static readonly type = getActionName('Delete');

    constructor(readonly payload: SequenceJsonModel) {
    }
  }

  export class Fetch {
    static readonly type = getActionName('Fetch');
    constructor(
      public overrideOptions?: {
        pageNumber?: number
        pageSize?: number
        skipStoreDispatch?: boolean
      }
    ) {
      this.overrideOptions = overrideOptions;
    }
  }

  export class FetchWithFilters {
    static readonly type = getActionName('Fetch with filters');

    constructor(
      public readonly filters: IFilters,
      public overrideOptions?: {
        pageNumber?: number
        pageSize?: number
        skipStoreDispatch?: boolean
      }
    ) {
      this.overrideOptions = overrideOptions;
    }
  }

  export class FetchAppend {
    static readonly type = getActionName('Fetch and append');
    constructor(
      public overrideOptions?: {
        pageNumber?: number
        pageSize?: number
        skipStoreDispatch?: boolean
      }
    ) {}
  }

  export class FetchSuccess {
    static readonly type = getActionName('Fetch success');

    constructor(readonly payload: SequenceJsonModel[]) {
    }
  }

  export class FetchSuccessAppend {
    static readonly type = getActionName('Fetch success append');

    constructor(readonly payload: SequenceJsonModel[]) {
    }
  }

  function getActionName(type: string) {
    return `[Sequence] ${type}`;
  }

}
